import { Quill } from "react-quill";
import QuillResizeImage from "quill-resize-image";

let registered = false;

/** Call once per app; avoids Quill "Overwriting modules/resize" when many editors import this. */
export function ensureQuillResizeRegistered() {
  if (registered) return;
  registered = true;
  Quill.register("modules/resize", QuillResizeImage);
}
